import React from 'react';

import type { CollectionListItem } from 'collections/types';
import type { ColumnRenderers } from 'components/common/EntityDataTable';
import CollectionTitleCell from 'collections/components/common/cells/CollectionTitleCell';

import SharedWithCell from './cells/SharedWithCell';

const customColumnRenderers: ColumnRenderers<CollectionListItem> = {
  attributes: {
    title: {
      renderCell: (title: CollectionListItem['title'], collection: CollectionListItem) => (
        <CollectionTitleCell title={title} id={collection.id} />
      ),
    },
    shared_with_users: {
      renderCell: (shared_with_users: CollectionListItem['shared_with_users'], collection: CollectionListItem) => (
        <SharedWithCell shared_with={shared_with_users} id={collection.id} title={collection.title} />
      ),
    },
    shared_with_teams: {
      renderCell: (shared_with_teams: CollectionListItem['shared_with_users'], collection: CollectionListItem) => (
        <SharedWithCell shared_with={shared_with_teams} id={collection.id} title={collection.title} />
      ),
    },
  },
};

export default customColumnRenderers;
